const autoLinkRender = str => {
  const skuPattern = /\b(?:\d{7})[^/\d]\b/g
  const urlPattern = /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,24}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi
  return str
    .replace(skuPattern, value => `<a href="/product/${value.trim()}" target="_blank">${value.trim()}</a>&nbsp;`)
    .replace(urlPattern, value => `<a href="${value.trim()}" target="_blank">click here</a>`)
}

export default autoLinkRender
